import { render, staticRenderFns } from "./NumberCom.vue?vue&type=template&id=0bb1b946&scoped=true&"
import script from "./NumberCom.vue?vue&type=script&lang=js&"
export * from "./NumberCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb1b946",
  null
  
)

export default component.exports